<template>
 <div>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom"  class="demo-form-inline" label-width="110px" size="mini" style="width: 100%;">
      <div class="formItemBox">
         <el-form-item label="客户名称:">
            <el-select  v-model="searchFrom.customerName" filterable placeholder="请选择">
              <el-option v-for="item in kehuList" :label="item.custerName" :value="item.custerName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓库名称:">
            <el-input  placeholder="" v-model="searchFrom.warehouseName"></el-input>
          </el-form-item>
      </div>
       <div class="searchBtnBox">
         <el-form-item  v-if="btnFlg[0]">
            <el-button type="primary" @click="getList(searchFrom)">查询</el-button>
          </el-form-item>
          <el-form-item  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm">重置</el-button>
          </el-form-item>
          <el-form-item  v-if="btnFlg[2]"  >
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
           <el-form-item  v-if="btnFlg[4]" >
            <el-button type="primary"  @click="delDeiver">删除</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border  class="tableComent">
      <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  v-if="btnFlg[3]"  @click="modifyRegion(scope.row)">修改</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="customerName" min-width="300"  :formatter="emptyFn" label="客户名称"></el-table-column>
        <el-table-column prop="warehouseName" min-width="300"  :formatter="emptyFn" label="仓库名称"></el-table-column>
        <el-table-column prop="createUser" min-width="120" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[20,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="isAdd?'添加':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="600px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
          <el-form-item label="客户名称:" prop="customerName" >
            <el-select  v-model="addFrom.customerName" filterable placeholder="请选择" v-if="isAdd" @change="kehuChange" >
              <el-option v-for="item in kehuList" :label="item.custerName" :value="item.custerName" :key="item.id"></el-option>
            </el-select>
            <div v-else>{{addFrom.customerName}}</div>
          </el-form-item>
          <el-form-item label="存货仓库:" prop="warehouseName" >
            已选<span class="red">{{multipleSelection.length}}</span>个库
          </el-form-item>
          <el-table height="60vh" size="mini" ref="tabref" :data="cangkuList"  border center @select='selectGoods'
          @selection-change="handleSelectionChange" @select-all="quanxuan($event)"  @row-click="rowClick" v-if="dialogVisible">
            <el-table-column type="selection" width="55" ></el-table-column>
            <el-table-column type="index"  label="序号" width="60"></el-table-column>
            <el-table-column prop="warehouseName"  label="仓库名称"></el-table-column>
          </el-table>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getRelationCustomer, zidianKuwei, findWarehouseCustomerListYh, deleteWarehouseCustomerListYh, updateWarehouseCustomerYh,
  addWarehouseCustomerYh, findAvailableWarehouseCustomerList } from '@/api/wms-stock.js'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  components: {

  },
  data () {
    return {
      isAdd: false,
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      title: '新增',
      dialogVisible: false,
      kehuList: [], // 客户列表
      cangkuList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      loading: 'false',
      rules: {
        customerName: [
          { required: true, message: '请选择客户名称', trigger: 'blur' }
        ]

      },
      addFrom: {},
      multipleSelection: [],
      delCKids: [],
      btnFlg: [],
      btnIdArr: ['003M4O0100', '003M4O0200', '003M4O0300', '003M4O0400', '003M4O0500', '003M4O0600']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    getRelationCustomer({}).then((res) => {
      this.kehuList = res
    }).catch((err) => {
      this.$message.error(err.message)
    })
    zidianKuwei({}).then((res) => {
      this.cangkuList = res
    }).catch((err) => {
      this.$message({
        message: err.message,
        type: 'error'
      })
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 200) + 'px'
  },
  methods: {
    rowClick (row, column, event) {
      let refsElTable = this.$refs.tabref // 获取表格对象
      let findRow = this.multipleSelection.find(c => c.warehouseId == row.warehouseId) // 找到选中的行
      if (findRow) {
        if (findRow.keyId) {
          this.delCKids.push(findRow.keyId)
        }
        refsElTable.toggleRowSelection(row, false) // 如过重复选中，则取消选中
      } else {
        if (row.keyId) {
          this.delCKids = this.delCKids.filter((item) => item !== row.keyId)
        }
        refsElTable.toggleRowSelection(row, true) // 实现选中行中选中事件
      }
      console.log([...new Set(this.delCKids)])
    },
    selectGoods (list, row) {
      if (!row) {
        return
      }
      let findRow = this.multipleSelection.find(c => c.warehouseId == row.warehouseId) // 找到选中的行
      console.log('findRow', findRow)
      if (findRow) {
        if (findRow.keyId) {
          this.delCKids.push(findRow.keyId)
        }
      } else {
        if (row.keyId) {
          this.delCKids = this.delCKids.filter((item) => item !== row.keyId)
        }
      }
      console.log([...new Set(this.delCKids)])
    },
    // 全选
    quanxuan (e) {
      if (e.length > 0) {
        this.delCKids = []
      } else {
        this.cangkuList.forEach(item => {
          if (item.keyId) {
            this.delCKids.push(item.keyId)
          }
        })
      }
    },
    // 表格选中事件
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 实现选中高亮
    rowClassName ({ row, rowIndex }) {
      let rowName = ''
      let findRow = this.multipleSelection.find(c => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row'
      } else {
        rowName = ''
      }
      return rowName // 也可以再加上其他类名 如果有需求的话
    },
    // 客户改变
    kehuChange (e) {
      let json1 = this.kehuList.filter(item => item.custerName == this.addFrom.customerName)
      findAvailableWarehouseCustomerList({ customerTaxId: json1[0].taxpayerNumber }).then(res => {
        if (res.length == 0) {
          this.$set(this.addFrom, 'customerTaxId', json1[0].taxpayerNumber)
        } else {
          this.$set(this.addFrom, 'customerName', null)
          this.$alert('此客户已配置，不能再新增！', '系统提示')
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.masterId = this.masterId
      findWarehouseCustomerListYh(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新增'
      this.addFrom = {}
      this.dialogVisible = true
      this.isAdd = true
    },
    // 修改
    modifyRegion (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.title = '修改'
      this.dialogVisible = true
      this.delCKids = []
      this.isAdd = false
      findAvailableWarehouseCustomerList({ customerTaxId: row.customerTaxId }).then(res => {
        if (res.length > 0) {
          this.cangkuList.forEach(item => {
            item.keyId = null
            let json = res.filter(val => val.warehouseId == item.warehouseId)
            if (json.length > 0) {
              item.keyId = json[0].id
              this.$refs.tabref.toggleRowSelection(item)
            } else {

            }
          })
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    saveFn (formName) {
      if (this.multipleSelection.length == 0) {
        this.$alert('请至少选择一个仓库', '系统提示')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.isAdd) {
            this.addFrom.addWarehouseList = this.multipleSelection
            addWarehouseCustomerYh(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            let newArr = []
            this.multipleSelection.forEach(item => {
              if (!item.keyId) {
                newArr.push(item)
              }
            })
            this.addFrom.addWarehouseList = newArr
            this.addFrom.deleteWarehouseList = [...new Set(this.delCKids)]
            updateWarehouseCustomerYh(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },

    // 删除
    delDeiver (row) {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteWarehouseCustomerListYh({ customerTaxIds: selectData.map(item => item.customerTaxId) }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = {}
      this.delCKids = []
      this.multipleSelection = []
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        dictionaryType: 'financial_settings'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox /deep/.el-input__inner{
  width: 178px;
}
.current-row{
  color: #409eff;
}
.searchBtnBox{
  margin: 0;
}
</style>
